module.exports = "/_next/static/images/Brent_Collins-5c20597118095dcba27ad36d4ba5883b.webp";